'use strict';
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.HotAreas = HotAreas;
var React = _interopRequireWildcard(require('react'));
var _gemsShared = require('@tencent/gems-shared');
var _actionHandler = require('./handlers/actionHandler');
function HotAreas(param) {
    var instance = param.instance, global = param.global, meta = param.meta;
    var hotAreas = instance.data.hotAreas;
    if (!hotAreas || !hotAreas.length) {
        return null;
    }
    return hotAreas.map(function(hotArea, index) {
        var size = hotArea.size, position = hotArea.position;
        return(/*#__PURE__*/ React.createElement(_actionHandler.HotAreaActionHandler, {
            key: index,
            instance: instance,
            hotArea: hotArea,
            meta: meta,
            global: global,
            style: {
                width: (0, _gemsShared.percent)(size.width),
                height: (0, _gemsShared.percent)(size.height),
                left: (0, _gemsShared.percent)(position.x),
                top: (0, _gemsShared.percent)(position.y),
                cursor: 'pointer',
                position: 'absolute',
                zIndex: 20
            }
        }));
    });
}
